import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Form, Button, Input, Row, Col } from 'antd';
import { useB2cDetail } from 'hooks';
import { Lecture, RangePicker } from 'components/atoms'
import { RangeValue } from 'rc-picker/lib/interface';
import { dateFormat } from 'utils/date-utils';
import moment, { Moment } from 'moment';
import { isEmpty } from 'utils/utils';

export interface B2cCopyModalProps extends PopupProps {
    id: number;
}

const B2cCopyModal = ({ 
    isOpen, 
    onClose, 
    id}: B2cCopyModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
    const [isFormDone, setIsFormDone] = useState<boolean>(false);
    const [startDate, setStartDate] = useState<string>();
    const [endDate, setEndDate] = useState<string>();
    const [lectureOpt, setLectureOpt] = useState<LectureCodeListDto>();
    
  /* ======================================================
  * hooks
  * ====================================================== */
  const { b2cInfo, copySuccess, b2cCopy } = useB2cDetail(id, ()=>{});

   /* ======================================================
   * variables
   * ====================================================== */
  const [form] = Form.useForm();
  const { TextArea } = Input;
   /* ======================================================
   * events
   * ====================================================== */
    const onCancel = () => {
        onClose?.(false);
    };

    const onSubmit = (e) => {
        if (id > 0) {
            b2cCopy({
                id: id,
                start_date: startDate,
                end_date: endDate,                             
            })  
        }
    };

    const onChangeForm = () => { 
        setIsFormDone(
            !(
                Number(form.getFieldValue('lectur_gid'))<1|| 
                (isEmpty(form.getFieldValue('project_date')))                 
            )
        );    
    };      
    
    const onChangePeriod = (date: RangeValue<Moment>, dateString: [string, string]) => {
   
        const searchDateS = dateString[0] ? dateFormat(dateString[0], 'YYYY-MM-DD') : undefined;
        const searchDateE = dateString[1] ? dateFormat(dateString[1], 'YYYY-MM-DD') : undefined;
    
        setStartDate(searchDateS);
        setEndDate(searchDateE);
        onChangeForm();
      };

    const onSelectLectur = (opt: LectureCodeListDto) => {
        setLectureOpt(opt)
    }      

  /* ======================================================
   * effects
   * ====================================================== */
    useEffect(() => {
        if (!!b2cInfo) {            
            if (!!b2cInfo.start_date && b2cInfo.start_date !== '0000-00-00' && !!b2cInfo.end_date && b2cInfo.end_date !== '0000-00-00') {
                setStartDate(b2cInfo.start_date);
                setEndDate(b2cInfo.end_date);
            }               
            form.setFieldsValue({
                lecture_gid: b2cInfo.lecture_gid || undefined, 
            });

        }
    }, [b2cInfo])

    useEffect(() => {
        if (copySuccess) {
            onClose?.(true);  
        }
    }, [copySuccess])

    return (
    <>
        <ModalWrapper open={isOpen} onCancel={onCancel} width={650} title={'공개과정 복사'} closable>
            <Form
                form={form}
                name="B2cInfo"
                layout="horizontal"  
                labelCol={{ flex: '120px' }}
                onFieldsChange={onChangeForm}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >
                <Row>
                    <Col span={15}>
                        <Form.Item name="lecture_gid" label={'과정'} rules={[{ required: true, message: '' }]}>
                            <Lecture form={form} onSelected={onSelectLectur} disable={id>0} />
                        </Form.Item> 
                    </Col> 
                    <Col span={9}> 
                        <Form.Item label={'회차'}>
                            {(id>0)?(b2cInfo?.lecture_cha):(lectureOpt?.cha)}
                        </Form.Item>   
                    </Col>            
                </Row>
                <Row>
                    <Col span={15}>
                        <Form.Item label={'금액'}>
                            {(id>0 && b2cInfo && b2cInfo.lecture_price)?(b2cInfo.lecture_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")):(lectureOpt)?(lectureOpt?.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")):'0'}
                        </Form.Item>                          
                    </Col> 
                    <Col span={9}> 
                        <Form.Item label={'할인여부'}>
                            {(id>0)?(b2cInfo?.lecture_sale_yn):(lectureOpt?.sale_yn)}
                        </Form.Item>   
                    </Col>            
                </Row>
                <Form.Item name="project_date" label={'교육 기간'} rules={[{ type: 'array' as const, required: true, message: '' }]}>
                    <RangePicker format="YYYY-MM-DD" onChange={onChangePeriod} style={{width:'250px'}} />                                   
                </Form.Item>    
                <ButtonGroup className={'buttonsWrapper'}>
                    <Button onClick={onCancel} style={{marginRight: "5px"}}>취소</Button>
                    <Button htmlType="submit"  type="primary" disabled={!isFormDone}>복사</Button>
                </ButtonGroup>                
            </Form>            
        </ModalWrapper>  
    </>
    )    
};

export default React.memo(B2cCopyModal);    